module.exports = __webpack_public_path__ + "img/20200611_075345.57d284dc.jpg";